module.exports = __webpack_public_path__ + "html/form-custom-template.template.html";